import AppButton from '@nxsys/components/AppButton';
import { useUploadAgencyFile } from '@nxsys/hooks/api/dashboard';
import { AppDispatch } from '@nxsys/store';
import { commonActions } from '@nxsys/store/slices/common/reducer/commonSlice';
import { UploadAgencyFileParams } from '@nxsys/types/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { showMessage } from '@nxsys/utils/message';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import AgencyUploadModal, { AgencyUploadValues } from './components/AgencyUploadModal';
import ViewAgencyUploadedFileModal from './components/ViewAgencyUploadedFileModal';

type Props = {
  agencyId: string;
};

const AgencyUploadFile: React.FC<Props> = ({ agencyId }) => {
  const dispatch = useDispatch<AppDispatch>();

  const [isOpenUploadModal, setIsOpenUploadModal] = useState(false);
  const [isOpenViewModal, setIsOpenViewModal] = useState(false);

  const { run: uploadAgencyFile } = useUploadAgencyFile();
  const handleUploadAgencyFile = async (values: AgencyUploadValues) => {
    const params: UploadAgencyFileParams = {
      fileType: values.fileType?.value || '',
      note: values.notes || '',
      fileName: values.documentFile.name,
      fileURL: '',
      fileSize: values.documentFile.size.toString(),
    };
    const { url } = await dispatch(
      commonActions.uploadFileToS3({ file: values.documentFile }),
    ).unwrap();
    params.fileURL = url;
    const res = await uploadAgencyFile(agencyId, params);
    if (res.success) {
      setIsOpenUploadModal(false);
      showMessage({
        type: 'success',
        content: 'Upload file success',
      });
    }
  };

  return (
    <div className="AgencyUploadFile">
      <div className="flex gap-x-[8px]">
        <AppButton name="Upload Files" variant='outlined' leftIcon={<Icons.IconPlus />} onClick={() => setIsOpenUploadModal(true)} />
        <AppButton name="View Files" variant='outlined' onClick={() => setIsOpenViewModal(true)} />
      </div>
      {isOpenUploadModal && (
        <AgencyUploadModal
          isOpen={isOpenUploadModal}
          toggle={() => setIsOpenUploadModal(false)}
          onSubmit={handleUploadAgencyFile}
        />
      )}
      {isOpenViewModal && (
        <ViewAgencyUploadedFileModal
          isOpen={isOpenViewModal}
          toggle={() => setIsOpenViewModal(false)}
          agencyId={agencyId}
        />
      )}
    </div>
  );
};

export default AgencyUploadFile;
